document.addEventListener("alpine:init", () => {
  Alpine.data("mc_handlecart", () => ({
    init() {},
    attributes: null,
    activateLinks() {},
    async updateQty(updates, quantity) {
      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
          sections: this.getSectionsToRender().map(
            (section) => section.section,
          ),
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then(async (cart) => {
          console.log(cart);
          this.$dispatch("cartupdated");

          if (typeof cartJS !== "undefined") {
            cartJS = cart;
          }

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              cart.sections[section.section],
              section.selector,
            );
          });

          const hasActivePlanItems = cart.items.some(
            (item) =>
              item.properties &&
              item.properties._planId !== undefined &&
              item.properties._planId !== "",
          );

          if (cart.items.length === 0 || !hasActivePlanItems) {
            console.log(
              "🧼 Group completely unmapped from session. Executing storefront data flush...",
            );
            await this.clearAllPlannerData(cart.token);
          }
        })
        .catch((error) => {
          console.error(
            "Error handling async quantity modification update loops:",
            error,
          );
        });
    },

    async clearAllPlannerData(cartToken) {
      console.log("🧼 Executing full session data purge workflow...");

      const STOREFRONT_ACCESS_TOKEN = "38ccb3dbf09a955fcb1839c518288034";
      const GRAPHQL_URL = `https://${window.location.hostname}/api/2026-04/graphql.json`;
      const CLEARED_METAFIELD_VALUE = "__MC_EMPTY__";

      if (cartToken) {
        try {
          const cartId = `gid://shopify/Cart/${cartToken}`;

          // We use aliases (del0, del1, etc.) to fire all 4 deletes in one single request
          // We pass exactly what the error asked for: ownerId and key.
          const query = `
            mutation deleteCartMetafields {
                del0: cartMetafieldDelete(input: { ownerId: "${cartId}", key: "matchless_planner.planUrl" }) {
                    deletedId
                    userErrors { field message }
                }
                del1: cartMetafieldDelete(input: { ownerId: "${cartId}", key: "matchless_planner.countertop_thickness" }) {
                    deletedId
                    userErrors { field message }
                }
                del2: cartMetafieldDelete(input: { ownerId: "${cartId}", key: "matchless_planner.planID" }) {
                    deletedId
                    userErrors { field message }
                }
                del3: cartMetafieldDelete(input: { ownerId: "${cartId}", key: "matchless_planner.version" }) {
                    deletedId
                    userErrors { field message }
                }
            }
        `;

          const response = await fetch(GRAPHQL_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
            },
            body: JSON.stringify({ query }),
          });

          const result = await response.json();

          // Check for any userErrors across all the aliases we sent
          const hasErrors = Object.values(result?.data || {}).some(
            (mutationResult) => mutationResult?.userErrors?.length > 0,
          );

          if (hasErrors || result.errors) {
            console.error(
              "Storefront metafield deletion returned errors:",
              result,
            );
          } else {
            console.log(
              "🧼 Successfully deleted Matchless Planner metafields from the Cart.",
            );
          }
        } catch (e) {
          console.error("Critical Storefront API delete execution failure:", e);
        }
      }

      await this.clearCartAttributes();
    },

    clearCart(event) {
      event.preventDefault();
      console.log("clearing cart");

      fetch(window.Shopify.routes.root + "cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json();
        })
        .then(async (cart) => {
          console.log("Cart cleared successfully:", cart);
          await this.clearAllPlannerData(cart.token);
          window.location.href = window.Shopify.routes.root + "cart";
        })
        .catch((error) => {
          console.error("Error clearing cart:", error);
        });
    },

    async saveDraft(event) {
      console.log(
        "Initiating client-first draft order compilation workflow...",
      );
      if (event) event.preventDefault();

      const STOREFRONT_ACCESS_TOKEN = "38ccb3dbf09a955fcb1839c518288034";
      const GRAPHQL_URL = `https://${window.location.hostname}/api/2026-04/graphql.json`;

      const cartCheck = await fetch(window.Shopify.routes.root + "cart.js");
      let cartObj = await cartCheck.json();

      const hasActivePlanItems = cartObj.items.some(
        (item) =>
          item.properties &&
          item.properties._planId !== undefined &&
          item.properties._planId !== "",
      );

      let embeddedMetafields = {};

      if (hasActivePlanItems) {
        try {
          const CLEARED_METAFIELD_VALUE = "__MC_EMPTY__";
          const cartId = `gid://shopify/Cart/${cartObj.token}`;
          const query = `
                          query getCartMetafieldsForDraft($id: ID!) {
                            cart(id: $id) {
                              metafields(identifiers: [
                                { namespace: "matchless_planner", key: "planUrl" },
                                { namespace: "matchless_planner", key: "countertop_thickness" },
                                { namespace: "matchless_planner", key: "planID" },
                                { namespace: "matchless_planner", key: "version" }
                              ]) {
                                key
                                value
                              }
                            }
                          }
                        `;

          const gqlRes = await fetch(GRAPHQL_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
            },
            body: JSON.stringify({ query, variables: { id: cartId } }),
          });

          const gqlResult = await gqlRes.json();
          const rawMetafields = gqlResult?.data?.cart?.metafields || [];

          rawMetafields.forEach((meta) => {
            if (meta) {
              embeddedMetafields[meta.key] =
                meta.value === CLEARED_METAFIELD_VALUE ? "" : meta.value;
            }
          });
        } catch (metaError) {
          console.error(
            "Non-blocking failure fetching client-side metafields for draft payload:",
            metaError,
          );
        }
      } else {
        console.log(
          "🧼 Plan items missing from cart. Hard-locking payload metafields to empty strings...",
        );
        embeddedMetafields = {
          planUrl: "",
          countertop_thickness: "",
          planID: "",
          version: "",
        };

        this.clearAllPlannerData(cartObj.token);
      }

      const finalPayload = {
        cart: cartObj,
        planner_metafields: {
          planUrl: embeddedMetafields["planUrl"] || "",
          countertop_thickness:
            embeddedMetafields["countertop_thickness"] || "",
          planID: embeddedMetafields["planID"] || "",
          version: embeddedMetafields["version"] || "",
        },
      };

      fetch(window.Shopify.routes.root + "tools/mp/Planner/SaveDraft", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(finalPayload),
      })
        .then((response) => {
          response.text().then((data) => {
            window.location.href = data;
          });
        })
        .catch((error) => {
          console.error("Error compiling Draft Order payload:", error);
        });
    },

    async clearCartAttributes() {
      return await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          attributes: {
            _planID: null,
            _planUrl: null,
            _plannerVersion: null,
            "Countertop Thickness": null,
          },
        }),
      });
    },

    getSectionsToRender() {
      return [
        {
          id: "cart-items",
          section: document.getElementById("cart-items").dataset.id,
          selector: ".container-large",
        },
      ];
    },
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    },
    async updateLineQty(event) {
      await this.updateLine(event, this.quantity);
    },
    async updateLine(event, qty) {
      let line = event.target.dataset.index;
      let linesToUpdate = {};

      try {
      } catch (error) {
        console.log("Error: " + error);
      }

      await fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => response.json())
        .then((cart) => {
          let lineItem = cart.items[line];
          let oldQty = cart.items[line].quantity;

          let quantity = 0;
          if (qty != undefined) {
            quantity = qty;
          }

          let targetPlanID = lineItem.properties
            ? lineItem.properties._planId || lineItem.properties._planID
            : null;

          if (targetPlanID) {
            console.log(
              `Processing drop instruction for plan cluster lines: ${targetPlanID}`,
            );
            cart.items.forEach((item) => {
              let itemPlanId = item.properties
                ? item.properties._planId || item.properties._planID
                : null;
              if (itemPlanId === targetPlanID) {
                linesToUpdate[item.key] = 0;
              }
            });
          } else {
            linesToUpdate[lineItem.key] = quantity;
            if (
              lineItem.properties != undefined &&
              lineItem.properties != null &&
              lineItem.properties._matchlessBuilderId != undefined &&
              lineItem.properties._matchlessBuilderId != ""
            ) {
              let parentId = lineItem.properties._matchlessBuilderId;
              let cLine = 0;
              cart.items.forEach((item) => {
                if (
                  cLine != line &&
                  item.properties._matchlessBuilderId != null &&
                  item.properties._matchlessBuilderId != ""
                ) {
                  if (item.properties._matchlessBuilderId == parentId) {
                    let childOldQty = item.quantity;
                    if (childOldQty == oldQty * 2) {
                      linesToUpdate[item.key] = quantity * 2;
                    } else {
                      linesToUpdate[item.key] = quantity;
                    }
                  }
                }
                cLine++;
              });
            }
          }

          this.updateQty(linesToUpdate, quantity);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
  }));
});
